const settings = {
  // domain: 'http://196.1.1.154:3000',
  domain: process.env.REACT_APP_URL,
  emailService: {
    serviceId: process.env.REACT_APP_EMAIL_YOUR_SERVICE_ID,
    templateId: process.env.REACT_APP_EMAIL_YOUR_TEMPLATE_ID,
    userId: process.env.REACT_APP_EMAIL_YOUR_USER_ID,
    publicKey: process.env.REACT_APP_YOUR_PUBLIC_KEY,
  },
}

export default settings;
